module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": "Myron",
      "subTitle": "sub title"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "icon": "account_circle"
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-title', {
    attrs: {
      "title": "Content Title",
      "subTitle": "Content Title"
    }
  }), _vm._v(" "), _c('mu-card-text', [_vm._v("\r\n    正文\r\n  ")]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "label": "Action 1"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50b74c5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/muse-ui/card.vue
// module id = 551
// module chunks = 1